import React, { useState, useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { addStyle, addClass, removeClass } from 'app/utils/domHelpers';
import { transitionEndEvent } from 'app/utils/helpers';
import AppliedFacetsList from './appliedFacetsList';
import { removeAllFacets as removeAllFacetsAction } from '../facetsListActions';
import './applied-facets.scss';

// TODO Needs to be refactored. Buggy logic. I've just replaced
// storing of local facet items array with their count. But this still needs
// to be re-thought
function AppliedFacets({ isMediumDown, appliedItemsCount, sizeIndicatorDisplayCallback, toggleRefineMenu }) {
  const dispatch = useDispatch();
  const appliedFacetsListWrapper = useRef(null);
  const [updateTrigger, forceUpdate] = useState(false);
  const [hasAppliedFacets, setHasAppliedFacets] = useState(false);
  const [localAppliedItemsCount, setLocalAppliedItemsCount] = useState(0);

  useEffect(() => {
    const currentHasAppliedFacets = appliedItemsCount > 0;
    const isLastSelectedFacet = localAppliedItemsCount === 1;

    if (!currentHasAppliedFacets && isLastSelectedFacet) {
      setLocalAppliedItemsCount(localAppliedItemsCount);
      forceUpdate(!updateTrigger);
    } else {
      setLocalAppliedItemsCount(appliedItemsCount);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [appliedItemsCount]);

  useEffect(() => {
    const currentHasAppliedFacets = appliedItemsCount > 0;
    const isLastSelectedFacet = localAppliedItemsCount === 1;

    animateAppliedFacets({
      animationType: currentHasAppliedFacets ? 'in' : 'out',
      appliedFacetsList: appliedFacetsListWrapper.current,
    }).then(() => {
      if (currentHasAppliedFacets !== hasAppliedFacets) {
        setHasAppliedFacets(currentHasAppliedFacets);
      }
      if (!currentHasAppliedFacets && isLastSelectedFacet) {
        setLocalAppliedItemsCount(0);
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [localAppliedItemsCount, updateTrigger]);

  const removeAllFacets = () => {
    dispatch(removeAllFacetsAction());
  };

  return (
    <>
      {isMediumDown && (
        <div className="applied-facets-heading">
          <div className="applied-facets-heading__title">
            <FormattedMessage id="products.productgrid.filterBy" description="Filters" />
          </div>
          <div className="applied-facets-heading__close">
            <button type="button" onClick={toggleRefineMenu}>
              <FormattedMessage id="products.productgrid.close" description="Close"/> <i className="fa-light fa-xmark" />
            </button>
          </div>
        </div>
      )}
      <div className="applied-facets-list applied-facets-animation" ref={appliedFacetsListWrapper}>
        <div className="applied-facets-list__container">
          <div className="applied-facets-list__heading">
            <p><FormattedMessage id="products.productgrid.selectedFilters"/></p>
            <button type="button" style={{ margin: 0 }} onClick={removeAllFacets}>
              <FormattedMessage id="products.productgrid.clearAll" description="Clear all" />
            </button>
          </div>
          <AppliedFacetsList sizeIndicatorDisplayCallback={sizeIndicatorDisplayCallback} />
        </div>
      </div>
    </>
  );
}

AppliedFacets.defaultProps = {
  isMediumDown: false,
  sizeIndicatorDisplayCallback: () => null,
  toggleRefineMenu: () => null,
};

AppliedFacets.propTypes = {
  isMediumDown: PropTypes.bool,
  appliedItemsCount: PropTypes.number.isRequired,
  sizeIndicatorDisplayCallback: PropTypes.func,
  toggleRefineMenu: PropTypes.func,
};

function animateAppliedFacets({ animationType, appliedFacetsList }) {
  const postAnimationDelay = () => new Promise(resolve => setTimeout(resolve, 100));

  const ANIMATION = {
    async in() {
      const height = appliedFacetsList.scrollHeight + 56;
      addStyle('max-height', `${height}px`, appliedFacetsList);
      addClass('applied-facets-animation--animate', appliedFacetsList);
      await transitionEndEvent(appliedFacetsList);
      return postAnimationDelay();
    },
    async out() {
      removeClass('applied-facets-animation--animate', appliedFacetsList);
      addStyle('max-height', 0, appliedFacetsList);
      await transitionEndEvent(appliedFacetsList);
      return postAnimationDelay();
    },
  };

  return ANIMATION[animationType]();
}

export default AppliedFacets;
